// now, on with the show!
import Header from './components/views/Header';
import InViewport from './components/views/InViewport';
import Services from './components/services';
import CustomFilters from './components/views/filter-page';

/**
 * The top-level controller for the whole page. This component is responsible
 * for loading other controllers and views.
 */
export default class TemplateApp {
  /**
   * Initialize all template specific JS components and `loadcomponents`
   * to initialize all unique JS components
   * @param {object} ComponentMap - Map of component names to component classes
   */
  constructor(ComponentMap) {
    this.ComponentMap = ComponentMap;
    /**
     * Services is the object which holds references to all services
     * created for pages. Services should be instantiated there and
     * then will be injected into each component for optional use via the
     * `loadcomponents` function
     * @type {Services}
     * @property {Services} Services - The object that holds references to all services created for pages.
     */
    this.Services = new Services();

    /**
     * The InViewport view component which needs to run globally for all components.
     * @type {InViewport}
     * @property {InViewport} inViewport - The InViewport view component used globally for all components.
     */
    this.inViewport = new InViewport(this.Services);

    this.header = new Header();
    this.customFilters = new CustomFilters();
  }

  /**
   * This function loops over all elements in the DOM with the
   * `data-loadcomponent` attribute and loads the specified view
   * or controller.
   *
   * To attach a JS component to an HTML element, in your markup you'd
   * do something like: <section class="example-component" data-loadcomponent='Examplecomponent'>
   * where 'Examplecomponent' is your JS class name. You'd need to add that component to the ./componentMap.js
   * and make sure the component exists and is a proper ES6 class, and then you'll end up with
   * an ES6 class that is passed a reference to section.example-component on init.
   */
  loadPagecomponents() {
    const attribute = 'data-loadcomponent';
    Array.prototype.forEach.call(
      document.querySelectorAll(`[${attribute}]`),
      function loadComponent(element) {
        // eslint-disable-next-line no-new
        new this.ComponentMap[element.getAttribute(attribute)](
          element,
          this.Services
        );
      }.bind(this)
    );
  }

  static jumpToAnchorLinks() {
    document.addEventListener('DOMContentLoaded', function handleAnchorLinks() {
      if (window.location.hash) {
        const element = document.querySelector(window.location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }
}
